import Card from 'components/ui/Card';
import Container from 'components/ui/Container';

interface SkeletonRoutineItemProps {
  className?: string;
}

const SkeletonRoutineItem: React.FC<SkeletonRoutineItemProps> = ({
  className
}) => {
  return (
    <Container
      as='div'
      className={`relative ${className ?? ''}`}
      variant='none'>
      <Card
        variant='default'
        size='large'
        className='flex flex-col ~gap-4/8 animate-pulse'>
        <div className='w-full grid grid-cols-1 lg:grid-cols-[1fr_auto] ~gap-5/10 items-start'>
          <div className='w-full flex items-start ~gap-2/3'>
            <div className='~w-5/10 ~h-5/10 rounded-md bg-primary-100 dark:bg-secondary-dark-300 border border-secondary-400/60 flex-shrink-0 ~mt-2/3' />

            <div className='flex-1 min-w-0'>
              <div className='w-full ~h-20/24 rounded-md border border-secondary-400/60 bg-primary-50 dark:bg-secondary-dark-300' />
            </div>
          </div>

          <div className='w-full lg:w-auto lg:min-w-fit flex flex-col ~gap-2/3 items-start lg:items-end justify-self-end'>
            {/* Segmented Control Skeleton */}
            <div className='w-full lg:w-auto inline-flex items-center p-0.5 ~gap-1/2 rounded-md border border-secondary-400/60 bg-primary-100 dark:bg-secondary-dark-300'>
              <div className='~px-3/4 ~py-1/1.5 rounded-md bg-white dark:bg-secondary-dark-300 ~w-20/24 ~h-7/8' />
              <div className='~px-3/4 ~py-1/1.5 rounded-md ~w-20/24 ~h-7/8' />
            </div>

            <div className='w-full flex flex-col sm:flex-row items-start sm:items-center ~gap-3/4'>
              <div className='flex items-center ~gap-2/3'>
                <div className='~w-16/20 ~h-10/12 rounded-md bg-primary-100 dark:bg-secondary-dark-300 border border-secondary-400/60' />
                <div className='~w-16/20 ~h-10/12 rounded-md bg-primary-100 dark:bg-secondary-dark-300 border border-secondary-400/60' />
              </div>
            </div>
          </div>
        </div>

        <div className='w-full flex flex-wrap items-center ~gap-2/3 ~mt-1/2'>
          <div className='h-6 rounded-full bg-primary-100 dark:bg-secondary-dark-300 ~px-2/3 ~w-48/56' />
          <div className='h-6 rounded-full bg-primary-100 dark:bg-secondary-dark-300 ~px-2/3 ~w-52/64' />
          <div className='h-6 rounded-full bg-primary-100 dark:bg-secondary-dark-300 ~px-2/3 ~w-44/52' />
          <div className='h-6 rounded-full bg-primary-100 dark:bg-secondary-dark-300 ~px-2/3 ~w-40/48' />
        </div>

        <div className='w-full ~h-10/12 rounded-md bg-primary-50 dark:bg-secondary-dark-300 border border-secondary-400/60 ~mt-2/3 ~px-3/4 ~py-2/3'>
          <div className='~w-3/4 h-3 rounded bg-primary-200 dark:bg-secondary-dark-400' />
        </div>

        <div className='w-full flex items-center justify-between border-t border-secondary-400/60 dark:border-secondary-dark-500 ~pt-2/3'>
          <div className='flex items-center ~gap-2/3'>
            <div className='~w-4/5 ~h-4/5 rounded bg-primary-100 dark:bg-secondary-dark-300' />
            <div className='~w-4/6 ~h-4/6 rounded bg-primary-100 dark:bg-secondary-dark-300' />
          </div>

          <div className='flex items-center ~gap-2/3'>
            <div className='~w-20/24 ~h-6/7 rounded bg-primary-100 dark:bg-secondary-dark-300' />
            <div className='~w-4/6 ~h-4/6 rounded bg-primary-100 dark:bg-secondary-dark-300' />
          </div>
        </div>
      </Card>
    </Container>
  );
};

export default SkeletonRoutineItem;
